import { useTranslation } from 'react-i18next';
import { Checkbox, SearchField } from '@heroui/react';
import { Segment } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils';
import {
    TRANSACTION_TYPE_FILTERS,
    TRANSACTION_TYPE_FILTER_LABEL_KEY,
    type TransactionTypeFilter,
} from './transactionsMeta';

import type { TransactionsFilterState } from './transactionsTypes';

type TransactionsFiltersProps = TransactionsFilterState;

export const TransactionsFilters = ({
    discountedOnly,
    setDiscountedOnly,
    search,
    setSearch,
    transactionType,
    setTransactionType,
}: TransactionsFiltersProps) => {
    const { t } = useTranslation('pages');
    return (
        <div
            className="flex flex-wrap items-center gap-3 px-4 py-3"
            {...getNodeTestIdProp('transactions-filters')}
        >
            <div {...getNodeTestIdProp('transactions-type-wrap')}>
                <Segment
                    aria-label={t('sales.widgets.transactions.types.label')}
                    onSelectionChange={(key) =>
                        setTransactionType(key as TransactionTypeFilter)
                    }
                    selectedKey={transactionType}
                    size="sm"
                    {...getNodeTestIdProp('transactions-type-segment')}
                >
                    {TRANSACTION_TYPE_FILTERS.map((value) => (
                        <Segment.Item
                            id={value}
                            key={value}
                            {...getNodeTestIdProp(
                                'transactions-type-option-' + value,
                            )}
                        >
                            <Segment.Separator />
                            {t(TRANSACTION_TYPE_FILTER_LABEL_KEY[value])}
                        </Segment.Item>
                    ))}
                </Segment>
            </div>
            <Checkbox
                isSelected={discountedOnly}
                onChange={setDiscountedOnly}
                {...getNodeTestIdProp('transactions-discounted-only')}
            >
                <Checkbox.Content>
                    <Checkbox.Control>
                        <Checkbox.Indicator />
                    </Checkbox.Control>
                    {t('sales.widgets.transactions.discountedOnly')}
                </Checkbox.Content>
            </Checkbox>
            <SearchField
                aria-label={t('sales.widgets.transactions.searchAria')}
                value={search}
                onChange={setSearch}
                className="w-full min-w-0 sm:ml-auto sm:w-56"
                {...getNodeTestIdProp('transactions-search-wrap')}
            >
                <SearchField.Group>
                    <SearchField.SearchIcon />
                    <SearchField.Input
                        placeholder={t(
                            'sales.widgets.transactions.searchPlaceholder',
                        )}
                        {...getNodeTestIdProp('transactions-search')}
                    />
                    <SearchField.ClearButton />
                </SearchField.Group>
            </SearchField>
        </div>
    );
};
